var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "900px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.handleClosed
      }
    },
    [
      _c(
        "el-form",
        { staticClass: "spsd-filter", attrs: { inline: true, size: "mini" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "标签" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "170px" },
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    filterable: "",
                    clearable: "",
                    placeholder: "选择标签"
                  },
                  on: { change: _vm.queryCustomers },
                  model: {
                    value: _vm.selectedLabelIds,
                    callback: function($$v) {
                      _vm.selectedLabelIds = $$v
                    },
                    expression: "selectedLabelIds"
                  }
                },
                _vm._l(_vm.labelGroups, function(g) {
                  return _c(
                    "el-option-group",
                    {
                      key: "g" + g.typeId,
                      attrs: {
                        label: g.typeName + "（" + g.labels.length + "）"
                      }
                    },
                    _vm._l(g.labels, function(lb) {
                      return _c(
                        "el-option",
                        {
                          key: lb.labelId,
                          attrs: { label: lb.labelName, value: lb.labelId }
                        },
                        [
                          _c("span", { staticClass: "spsd-opt" }, [
                            _c("i", {
                              staticClass: "spsd-opt-color",
                              style: { background: lb.color || "#409EFF" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "spsd-opt-name" }, [
                              _vm._v(_vm._s(lb.labelName))
                            ])
                          ])
                        ]
                      )
                    }),
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "组织机构" } },
            [
              _c("ybl-organization", {
                staticStyle: { width: "220px" },
                attrs: { "show-checkbox": true, placeholder: "请选择组织机构" },
                model: {
                  value: _vm.selectedOrgIds,
                  callback: function($$v) {
                    _vm.selectedOrgIds = $$v
                  },
                  expression: "selectedOrgIds"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "关键字" } },
            [
              _c("el-input", {
                staticStyle: { width: "150px" },
                attrs: { placeholder: "姓名/登录名/手机号", clearable: "" },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.queryCustomers.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.keyword,
                  callback: function($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.queryCustomers }
                },
                [_vm._v("查询")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { "min-height": "160px" }
        },
        [
          _c(
            "el-table",
            {
              ref: "hitTable",
              attrs: {
                data: _vm.hitCustomers,
                size: "mini",
                border: "",
                "max-height": "280",
                "row-key": "customerId",
                "reserve-selection": true
              },
              on: { "selection-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "42" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "姓名", prop: "realName", "min-width": "90" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "工号", prop: "personCode", "min-width": "120" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "登录名", prop: "loginName", "min-width": "90" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "手机号", prop: "mobile", "min-width": "110" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "组织机构", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.organizationName ||
                              scope.row.branchName ||
                              ""
                          )
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "标签", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(scope.row.labelList || [], function(lb) {
                        return _c(
                          "span",
                          { key: lb.labelId, staticClass: "spsd-cell-tag" },
                          [
                            _c("i", {
                              staticClass: "spsd-cell-dot",
                              style: { background: lb.color || "#409EFF" }
                            }),
                            _vm._v(_vm._s(lb.labelName) + "\n          ")
                          ]
                        )
                      })
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading && _vm.hitCustomers.length === 0
            ? _c("div", { staticClass: "spsd-empty" }, [
                _vm._v("请选择标签/组织/关键字后查询，或当前条件下暂无人员")
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.pickedList.length
        ? _c(
            "div",
            { staticClass: "spsd-picked" },
            [
              _c("div", { staticClass: "spsd-picked-title" }, [
                _vm._v("已选人员（" + _vm._s(_vm.pickedList.length) + "）：")
              ]),
              _vm._v(" "),
              _vm._l(_vm.pickedList, function(p) {
                return _c(
                  "el-tag",
                  {
                    key: p.customerId,
                    staticClass: "spsd-picked-tag",
                    attrs: { closable: "", size: "mini" },
                    on: {
                      close: function($event) {
                        return _vm.removePicked(p)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(p.realName || p.customerId) +
                        "（" +
                        _vm._s(p.customerId) +
                        "）"
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确 定（已选 " + _vm._s(_vm.pickedList.length) + " 人）")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a8509f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a8509f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SalesPersonSelectDialog.vue
// module id = null
// module chunks = 